import {DictionaryObjectItem} from "PDFLib/core/writers/JSONWriter/JSONItem/DictionaryObjectItem";

export class FieldJSONItem extends DictionaryObjectItem
{

    GetType(): string {
        return 'FD';
    }
}